import { FormInstance } from "antd/es/form";
import { Guid } from "guid-typescript";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface ITalepForm_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface ITalepForm_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  IssuesSave: number;
  IssuesSave_dummy: number;
  DeleteFromSessionStorage: string;
  DeleteFromSessionStorage_dummy: string;
  GoBack: any;
  GoBack_dummy: any;
  ReadFromSessionStorage: string;
  ReadFromSessionStorage_dummy: string;
  SetValueOf: any;
  SetValueOf_dummy: any;
  DealerContextByKuserId: any[];
  DealerContextByKuserId_dummy: any[];
  ParentDealerByDealerId: any[];
  ParentDealerByDealerId_dummy: any[];
  IssueDocumentsCount: any[];
  IssueDocumentsCount_dummy: any[];
  IssuesById: any[];
  IssuesById_dummy: any[];
  SelectIssueImages: any[];
  SelectIssueImages_dummy: any[];
  IssuesImageCount: any[];
  IssuesImageCount_dummy: any[];
  isWeb: boolean;
  isWeb_dummy: boolean;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  IfThenElse: boolean;
  IfThenElse_dummy: boolean;
  IssuesSaveDummy: number;
  IssuesSaveDummy_dummy: number;
  IssuesImageSave: number;
  IssuesImageSave_dummy: number;
  ToggleVisibilityOf: string;
  ToggleVisibilityOf_dummy: string;
  IssueMessagesDelete: number;
  IssueMessagesDelete_dummy: number;
  isComp994903Visible: "visible" | "hidden";
  isComp415913Visible: "visible" | "hidden";
  isComp566084Visible: "visible" | "hidden";
  isComp647230Visible: "visible" | "hidden";
}

export class TalepForm_ScreenBase extends React.PureComponent<
  ITalepForm_ScreenProps,
  any
> {
  talepform_136572_value_kuikaSelectBoxRef: React.RefObject<any>;
  talepform_668502_value_kuikaFlexGridRef: React.RefObject<any>;
  ml = [
    {
      Id: "f6e17cbf-9877-1e37-1dda-7f0e2f0194a4",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "58f12691-42c0-4569-8d3d-7de148711af0",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [],
    },
    {
      Id: "cd8c4a62-924f-4a49-a57a-d96586014709",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 816894, PropertyName: "label", Value: "Kaydet" },
        { Id: 228382, PropertyName: "value", Value: "Talep Form" },
        { Id: 915029, PropertyName: "value", Value: "Ana Talep Görseli" },
        {
          Id: 88280,
          PropertyName: "value",
          Value:
            "En iyi görüntüleme için lütfen 2:1 oranında (genişlik:yükseklik) görsel yükleyiniz.",
        },
        { Id: 738506, PropertyName: "label", Value: "Fotoğraf Yükle" },
        { Id: 806472, PropertyName: "label", Value: "Fotoğrafı Sil" },
        { Id: 180300, PropertyName: "value", Value: "Başlık" },
        { Id: 629343, PropertyName: "placeholder", Value: "Başlık yazın..." },
        { Id: 97622, PropertyName: "value", Value: "Muhatap Seçimi" },
        { Id: 136572, PropertyName: "placeholder", Value: "Muhatap seçin..." },
        { Id: 273345, PropertyName: "value", Value: "İçerik" },
        {
          Id: 763677,
          PropertyName: "placeholder",
          Value: "Taleple ilgili içeriği girin...",
        },
        { Id: 587725, PropertyName: "value", Value: "Link" },
        { Id: 676308, PropertyName: "placeholder", Value: "Link ekleyin..." },
        { Id: 641982, PropertyName: "value", Value: "Belgeler" },
        { Id: 808980, PropertyName: "value", Value: "Daha fazla görsel yükle" },
        { Id: 8911, PropertyName: "value", Value: "Yüklenen Görseller" },
        {
          Id: 668502,
          PropertyName: "nodatafoundmessage",
          Value: "No data found.",
        },
        { Id: 289090, PropertyName: "value", Value: "Sil" },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  constructor(props) {
    super(props);
    this.talepform_629343_value_kuikaTextInputRef = React.createRef();
    this.talepform_136572_value_kuikaSelectBoxRef = React.createRef();
    this.talepform_668502_value_kuikaFlexGridRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      IssuesSave: 0,
      DeleteFromSessionStorage: "",
      GoBack: "",
      ReadFromSessionStorage: "",
      SetValueOf: "",
      DealerContextByKuserId: [],
      ParentDealerByDealerId: [],
      IssueDocumentsCount: [],
      IssuesById: [],
      SelectIssueImages: [],
      IssuesImageCount: [],
      isWeb: false,
      IfThenElse: false,
      IssuesSaveDummy: 0,
      NAVIGATE: "",
      ToggleVisibilityOf: "",
      IssueMessagesDelete: 0,
      isComp994903Visible: "hidden",
      isComp415913Visible: "visible",
      isComp566084Visible: "hidden",
      isComp647230Visible: "hidden",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("talepform", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.TalepFormPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("talepform", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("talepform", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.TalepFormPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      talepform_629343_value:
        this.state.IssuesById?.at?.(0)?.title ?? undefined,
      talepform_136572_value:
        this.state.IssuesById?.at?.(0)?.assignedTo ?? undefined,
      talepform_763677_value:
        this.state.IssuesById?.at?.(0)?.content ?? undefined,
      talepform_676308_value:
        this.state.IssuesById?.at?.(0)?.externalLink ?? undefined,
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  TalepFormPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.ReadFromSessionStorage =
      await ReactSystemFunctions.readFromSessionStorage(
        ReactSystemFunctions.convertToTypeByName("IssuePhoto", "string")
      );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "talepform_458656_value",
        "string"
      ),
      ReactSystemFunctions.value(this, stateVars.ReadFromSessionStorage),
      null,
      false
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.TalepFormPageInit1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  TalepFormPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      KuserID_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUserId(),
        "Guid"
      ),
      DealerId_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.DealerContextByKuserId !== undefined
            ? stateVars.DealerContextByKuserId?.length > 0
              ? stateVars.DealerContextByKuserId[0].id
              : null
            : this.state.DealerContextByKuserId?.length > 0
            ? this.state.DealerContextByKuserId[0].id
            : null
        ),
        "Guid"
      ),
      IssueID_2: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.IssueID ?? this.props.screenInputs.issueid,
        "Guid"
      ),
      Id_3: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.IssueID ?? this.props.screenInputs.issueid,
        "Guid"
      ),
      IssuesId_4: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.IssueID ?? this.props.screenInputs.issueid,
        "Guid"
      ),
      IssueID_5: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.IssueID ?? this.props.screenInputs.issueid,
        "Guid"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "TalepForm/TalepFormPageInit1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.DealerContextByKuserId = result?.data.dealerContextByKuserId;
    stateVars.ParentDealerByDealerId = result?.data.parentDealerByDealerId;

    formVars.talepform_136572_value =
      stateVars.IssuesById !== undefined
        ? stateVars.IssuesById?.length > 0
          ? stateVars.IssuesById[0].assignedTo
          : null
        : this.state.IssuesById?.length > 0
        ? this.state.IssuesById[0].assignedTo
        : null;
    formVars.talepform_136572_options = stateVars.ParentDealerByDealerId;
    stateVars.IssueDocumentsCount = result?.data.issueDocumentsCount;
    formVars.talepform_647230_value = ReactSystemFunctions.toString(
      this,
      stateVars.IssueDocumentsCount !== undefined
        ? stateVars.IssueDocumentsCount?.length > 0
          ? stateVars.IssueDocumentsCount[0].issueDocumentCountWithbrackets
          : null
        : this.state.IssueDocumentsCount?.length > 0
        ? this.state.IssueDocumentsCount[0].issueDocumentCountWithbrackets
        : null
    );
    stateVars.isComp647230Visible =
      ReactSystemFunctions.isGreaterThan(
        ReactSystemFunctions.value(
          this,
          stateVars.IssueDocumentsCount !== undefined
            ? stateVars.IssueDocumentsCount?.length > 0
              ? stateVars.IssueDocumentsCount[0].issueDocumentCount
              : null
            : this.state.IssueDocumentsCount?.length > 0
            ? this.state.IssueDocumentsCount[0].issueDocumentCount
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.IssuesById = result?.data.issuesById;
    formVars.talepform_629343_value = ReactSystemFunctions.toString(
      this,
      stateVars.IssuesById !== undefined
        ? stateVars.IssuesById?.length > 0
          ? stateVars.IssuesById[0].title
          : null
        : this.state.IssuesById?.length > 0
        ? this.state.IssuesById[0].title
        : null
    );
    formVars.talepform_136572_value =
      stateVars.IssuesById !== undefined
        ? stateVars.IssuesById?.length > 0
          ? stateVars.IssuesById[0].assignedTo
          : null
        : this.state.IssuesById?.length > 0
        ? this.state.IssuesById[0].assignedTo
        : null;
    formVars.talepform_136572_options = stateVars.ParentDealerByDealerId;
    formVars.talepform_763677_value = ReactSystemFunctions.toString(
      this,
      stateVars.IssuesById !== undefined
        ? stateVars.IssuesById?.length > 0
          ? stateVars.IssuesById[0].content
          : null
        : this.state.IssuesById?.length > 0
        ? this.state.IssuesById[0].content
        : null
    );
    formVars.talepform_676308_value = ReactSystemFunctions.toString(
      this,
      stateVars.IssuesById !== undefined
        ? stateVars.IssuesById?.length > 0
          ? stateVars.IssuesById[0].externalLink
          : null
        : this.state.IssuesById?.length > 0
        ? this.state.IssuesById[0].externalLink
        : null
    );
    stateVars.SelectIssueImages = result?.data.selectIssueImages;

    stateVars.IssuesImageCount = result?.data.issuesImageCount;
    formVars.talepform_865184_value = ReactSystemFunctions.toString(
      this,
      stateVars.IssuesImageCount !== undefined
        ? stateVars.IssuesImageCount?.length > 0
          ? stateVars.IssuesImageCount[0].imageCountWithBracket
          : null
        : this.state.IssuesImageCount?.length > 0
        ? this.state.IssuesImageCount[0].imageCountWithBracket
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.TalepFormPageInit2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  TalepFormPageInit2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.talepform_629343_value = ReactSystemFunctions.toString(
      this,
      stateVars.IssuesById !== undefined
        ? stateVars.IssuesById?.length > 0
          ? stateVars.IssuesById[0].title
          : null
        : this.state.IssuesById?.length > 0
        ? this.state.IssuesById[0].title
        : null
    );

    formVars.talepform_136572_value = ReactSystemFunctions.toString(
      this,
      stateVars.IssuesById !== undefined
        ? stateVars.IssuesById?.length > 0
          ? stateVars.IssuesById[0].assignedTo
          : null
        : this.state.IssuesById?.length > 0
        ? this.state.IssuesById[0].assignedTo
        : null
    );

    stateVars.dataSource_136572 =
      stateVars.ParentDealerByDealerId ?? this.state.ParentDealerByDealerId;
    stateVars.dataSource_136572 =
      stateVars.ParentDealerByDealerId ?? this.state.ParentDealerByDealerId;
    formVars.talepform_763677_value = ReactSystemFunctions.toString(
      this,
      stateVars.IssuesById !== undefined
        ? stateVars.IssuesById?.length > 0
          ? stateVars.IssuesById[0].content
          : null
        : this.state.IssuesById?.length > 0
        ? this.state.IssuesById[0].content
        : null
    );

    formVars.talepform_676308_value = ReactSystemFunctions.toString(
      this,
      stateVars.IssuesById !== undefined
        ? stateVars.IssuesById?.length > 0
          ? stateVars.IssuesById[0].externalLink
          : null
        : this.state.IssuesById?.length > 0
        ? this.state.IssuesById[0].externalLink
        : null
    );

    formVars.talepform_647230_value = ReactSystemFunctions.toString(
      this,
      stateVars.IssueDocumentsCount !== undefined
        ? stateVars.IssueDocumentsCount?.length > 0
          ? stateVars.IssueDocumentsCount[0].issueDocumentCountWithbrackets
          : null
        : this.state.IssueDocumentsCount?.length > 0
        ? this.state.IssueDocumentsCount[0].issueDocumentCountWithbrackets
        : null
    );

    stateVars.isComp647230Visible =
      ReactSystemFunctions.isGreaterThan(
        ReactSystemFunctions.value(
          this,
          stateVars.IssueDocumentsCount !== undefined
            ? stateVars.IssueDocumentsCount?.length > 0
              ? stateVars.IssueDocumentsCount[0].issueDocumentCount
              : null
            : this.state.IssueDocumentsCount?.length > 0
            ? this.state.IssueDocumentsCount[0].issueDocumentCount
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.talepform_865184_value = ReactSystemFunctions.toString(
      this,
      stateVars.IssuesImageCount !== undefined
        ? stateVars.IssuesImageCount?.length > 0
          ? stateVars.IssuesImageCount[0].imageCountWithBracket
          : null
        : this.state.IssuesImageCount?.length > 0
        ? this.state.IssuesImageCount[0].imageCountWithBracket
        : null
    );

    stateVars.dataSource_668502 =
      stateVars.SelectIssueImages ?? this.state.SelectIssueImages;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  TalepFormComponent_816894_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "talepform_136572_value",
          "value",
          "ParentDealerByDealerId",
          "id",
          ""
        ),
        null
      ),
      message: "*",
      formName: "talepform_136572_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "talepform_629343_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "*",
      formName: "talepform_629343_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "talepform_763677_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "*",
      formName: "talepform_763677_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Id_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.IssueID ?? this.props.screenInputs.issueid,
        "Guid"
      ),
      AssignedTo_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "talepform_136572_value",
            "value",
            "ParentDealerByDealerId",
            "id",
            "id"
          )
        ),
        "string"
      ),
      CreatedDealerId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.DealerContextByKuserId !== undefined
            ? stateVars.DealerContextByKuserId?.length > 0
              ? stateVars.DealerContextByKuserId[0].id
              : null
            : this.state.DealerContextByKuserId?.length > 0
            ? this.state.DealerContextByKuserId[0].id
            : null
        ),
        "Guid"
      ),
      Title_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "talepform_629343_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      Content_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "talepform_763677_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      ExternalLink_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "talepform_676308_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      ImageId_0: ReactSystemFunctions.convertToTypeByName(
        Guid.create().toString(),
        "Guid"
      ),
      ImageBase64_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "talepform_458656_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "TalepForm/TalepFormComponent_816894_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.IssuesSave = result?.data.issuesSave;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.TalepFormComponent_816894_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  TalepFormComponent_816894_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.DeleteFromSessionStorage =
      await ReactSystemFunctions.deleteFromSessionStorage(
        ReactSystemFunctions.convertToTypeByName("IssuePhoto", "string")
      );
    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  TalepFormComponent_686287_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  TalepFormComponent_121952_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.DeleteFromSessionStorage =
      await ReactSystemFunctions.deleteFromSessionStorage(
        ReactSystemFunctions.convertToTypeByName("IssuePhoto", "string")
      );
    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  TalepFormComponent_738506_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.isWeb = await ReactSystemFunctions.isWeb();

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.TalepFormComponent_738506_onClick1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  TalepFormComponent_738506_onClick_if1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "FotoDrawer",
      "sessionName",
      ReactSystemFunctions.convertToTypeByName("IssuePhoto", "string")
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      this.TalepFormComponent_738506_onClick_if11_,
      "TalepForm",
      "FotoDrawer",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "700686",
      null,
      "bottom",
      "true",
      "100vw",
      "40vh",
      false,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };
  TalepFormComponent_738506_onClick_if11_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.ReadFromSessionStorage =
      await ReactSystemFunctions.readFromSessionStorage(
        ReactSystemFunctions.convertToTypeByName("IssuePhoto", "string")
      );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "talepform_458656_value",
        "string"
      ),
      ReactSystemFunctions.value(this, stateVars.ReadFromSessionStorage),
      null,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  TalepFormComponent_738506_onClick_else1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "FotoDrawer",
      "sessionName",
      ReactSystemFunctions.convertToTypeByName("IssuePhoto", "string")
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      this.TalepFormComponent_738506_onClick_else11_,
      "TalepForm",
      "FotoDrawer",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "295904",
      null,
      "bottom",
      "true",
      "100vw",
      "40vh",
      false,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };
  TalepFormComponent_738506_onClick_else11_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.ReadFromSessionStorage =
      await ReactSystemFunctions.readFromSessionStorage(
        ReactSystemFunctions.convertToTypeByName("IssuePhoto", "string")
      );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "talepform_458656_value",
        "string"
      ),
      ReactSystemFunctions.value(this, stateVars.ReadFromSessionStorage),
      null,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  TalepFormComponent_738506_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, this.state.isWeb),
        true
      )
    ) {
      isErrorOccurred = await this.TalepFormComponent_738506_onClick_if1();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred = await this.TalepFormComponent_738506_onClick_else1();
      if (isErrorOccurred) return true;
    }

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  TalepFormComponent_806472_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "talepform_458656_value",
        "string"
      ),
      "",
      null,
      false
    );
    stateVars.DeleteFromSessionStorage =
      await ReactSystemFunctions.deleteFromSessionStorage(
        ReactSystemFunctions.convertToTypeByName("IssuePhoto", "string")
      );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  TalepFormComponent_149110_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Id_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.IssueID ?? this.props.screenInputs.issueid,
        "Guid"
      ),
      Title_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "talepform_629343_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      Content_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "talepform_763677_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      AssignedTo_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "talepform_136572_value",
            "value",
            "ParentDealerByDealerId",
            "id",
            "id"
          )
        ),
        "string"
      ),
      ExternalLink_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "talepform_676308_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "TalepForm/TalepFormComponent_149110_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.IssuesSaveDummy = result?.data.issuesSaveDummy;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.TalepFormComponent_149110_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  TalepFormComponent_149110_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "TalepBelgeList",
      "IssueD",
      ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.IssueID ?? this.props.screenInputs.issueid,
        "Guid"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "TalepForm",
      "TalepBelgeList",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  TalepFormComponent_349771_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Id_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.IssueID ?? this.props.screenInputs.issueid,
        "Guid"
      ),
      Title_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "talepform_629343_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      Content_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "talepform_763677_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      AssignedTo_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "talepform_136572_value",
            "value",
            "ParentDealerByDealerId",
            "id",
            "id"
          )
        ),
        "string"
      ),
      ExternalLink_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "talepform_676308_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "TalepForm/TalepFormComponent_349771_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.IssuesSaveDummy = result?.data.issuesSaveDummy;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.TalepFormComponent_349771_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  TalepFormComponent_349771_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.isWeb = await ReactSystemFunctions.isWeb();

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.TalepFormComponent_349771_onClick2_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  TalepFormComponent_349771_onClick_if2 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "FotoDrawer",
      "sessionName",
      ReactSystemFunctions.convertToTypeByName("IssuePhoto", "string")
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      this.TalepFormComponent_349771_onClick_if21_,
      "TalepForm",
      "FotoDrawer",
      "",
      "9924ef5f-4b84-4200-b624-8d76348c7686",
      "78724",
      null,
      null,
      "true",
      "400vw",
      "250px",
      false,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };
  TalepFormComponent_349771_onClick_if21_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.ReadFromSessionStorage =
      await ReactSystemFunctions.readFromSessionStorage(
        ReactSystemFunctions.convertToTypeByName("IssuePhoto", "string")
      );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.TalepFormComponent_349771_onClick_if22_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  TalepFormComponent_349771_onClick_if22_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      IssueId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.IssueID ?? this.props.screenInputs.issueid,
        "Guid"
      ),
      ImageId_0: ReactSystemFunctions.convertToTypeByName(
        Guid.create().toString(),
        "Guid"
      ),
      ImageBase64_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, this.state.ReadFromSessionStorage),
        "string"
      ),
      IssuesId_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.IssueID ?? this.props.screenInputs.issueid,
        "Guid"
      ),
      IssueID_2: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.IssueID ?? this.props.screenInputs.issueid,
        "Guid"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "TalepForm/TalepFormComponent_349771_onClick_if22_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.IssuesImageSave = result?.data.issuesImageSave;
    stateVars.SelectIssueImages = result?.data.selectIssueImages;

    stateVars.IssuesImageCount = result?.data.issuesImageCount;
    formVars.talepform_865184_value = ReactSystemFunctions.toString(
      this,
      stateVars.IssuesImageCount !== undefined
        ? stateVars.IssuesImageCount?.length > 0
          ? stateVars.IssuesImageCount[0].imageCountWithBracket
          : null
        : this.state.IssuesImageCount?.length > 0
        ? this.state.IssuesImageCount[0].imageCountWithBracket
        : null
    );
    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };

  TalepFormComponent_349771_onClick_else2 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "FotoDrawer",
      "sessionName",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("IssuePhoto", "string"),
        "string"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      this.TalepFormComponent_349771_onClick_else21_,
      "TalepForm",
      "FotoDrawer",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "780055",
      null,
      "right",
      "true",
      "100vw",
      "40vh",
      false,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };
  TalepFormComponent_349771_onClick_else21_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.ReadFromSessionStorage =
      await ReactSystemFunctions.readFromSessionStorage(
        ReactSystemFunctions.convertToTypeByName("IssuePhoto", "string")
      );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.TalepFormComponent_349771_onClick_else22_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  TalepFormComponent_349771_onClick_else22_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      IssueId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.IssueID ?? this.props.screenInputs.issueid,
        "Guid"
      ),
      ImageId_0: ReactSystemFunctions.convertToTypeByName(
        Guid.create().toString(),
        "Guid"
      ),
      ImageBase64_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, this.state.ReadFromSessionStorage),
        "string"
      ),
      IssuesId_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.IssueID ?? this.props.screenInputs.issueid,
        "Guid"
      ),
      IssueID_2: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.IssueID ?? this.props.screenInputs.issueid,
        "Guid"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "TalepForm/TalepFormComponent_349771_onClick_else22_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.IssuesImageSave = result?.data.issuesImageSave;
    stateVars.SelectIssueImages = result?.data.selectIssueImages;

    stateVars.IssuesImageCount = result?.data.issuesImageCount;
    formVars.talepform_865184_value = ReactSystemFunctions.toString(
      this,
      stateVars.IssuesImageCount !== undefined
        ? stateVars.IssuesImageCount?.length > 0
          ? stateVars.IssuesImageCount[0].imageCountWithBracket
          : null
        : this.state.IssuesImageCount?.length > 0
        ? this.state.IssuesImageCount[0].imageCountWithBracket
        : null
    );
    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };

  TalepFormComponent_349771_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, this.state.isWeb),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      )
    ) {
      isErrorOccurred = await this.TalepFormComponent_349771_onClick_if2();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred = await this.TalepFormComponent_349771_onClick_else2();
      if (isErrorOccurred) return true;
    }

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  TalepFormComponent_994903_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.ToggleVisibilityOf =
      await ReactSystemFunctions.toggleVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp994903Visible",
          "string"
        )
      );
    stateVars.ToggleVisibilityOf =
      await ReactSystemFunctions.toggleVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp415913Visible",
          "string"
        )
      );
    stateVars.ToggleVisibilityOf =
      await ReactSystemFunctions.toggleVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp566084Visible",
          "string"
        )
      );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  TalepFormComponent_415913_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.ToggleVisibilityOf =
      await ReactSystemFunctions.toggleVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp994903Visible",
          "string"
        )
      );
    stateVars.ToggleVisibilityOf =
      await ReactSystemFunctions.toggleVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp415913Visible",
          "string"
        )
      );
    stateVars.ToggleVisibilityOf =
      await ReactSystemFunctions.toggleVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp566084Visible",
          "string"
        )
      );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  TalepFormComponent_289090_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Id_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "talepform_668502_value", "id"),
        "Guid"
      ),
      IssuesId_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.IssueID ?? this.props.screenInputs.issueid,
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "TalepForm/TalepFormComponent_289090_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.IssueMessagesDelete = result?.data.issueMessagesDelete;
    stateVars.SelectIssueImages = result?.data.selectIssueImages;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.TalepFormComponent_289090_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  TalepFormComponent_289090_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_668502 =
      stateVars.SelectIssueImages ?? this.state.SelectIssueImages;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.TalepFormPageInit();
    }
    if (diId == 700686) {
      isErrorOccurred = await this.TalepFormComponent_738506_onClick_if11_();
      if (isErrorOccurred) return true;
    } else if (diId == 295904) {
      isErrorOccurred = await this.TalepFormComponent_738506_onClick_else11_();
      if (isErrorOccurred) return true;
    } else if (diId == 78724) {
      isErrorOccurred = await this.TalepFormComponent_349771_onClick_if21_();
      if (isErrorOccurred) return true;
    } else if (diId == 780055) {
      isErrorOccurred = await this.TalepFormComponent_349771_onClick_else21_();
      if (isErrorOccurred) return true;
    }
  }
}
